import script from "./ListsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ListsTable.vue?vue&type=script&setup=true&lang=js"

import "./ListsTable.vue?vue&type=style&index=0&id=31cab90f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31cab90f"]])

export default __exports__